import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ToggleLinksInput from "../../../../parts/inputs/toggle-links-input";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import DropdownIconsCheck from "../../../../parts/inputs/dropdown-icons-check";
import TablistNav from "../../../../parts/inputs/TablistNav";
import { getRoleNameById } from "../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import ChooseCoach from "../../../dashboard/settings/manage-coaches/ChooseCoach";
import SelectGroupsForMobileScreen from "./SelectGroupsForMobileScreen";

const SORT_ITEMS = [
  {
    title: "A-Z",
    src: "/img/svg/vuesax-linear-tick-square.svg",
    alt: "asc",
    className: "grey",
    id: JSON.stringify([["name"], ["asc"]]),
  },
  {
    title: "Z-A",
    src: "/img/svg/vuesax-linear-tick-square.svg",
    alt: "desc",
    className: "grey",
    id: JSON.stringify([["name"], ["desc"]]),
  },
  {
    title: "Last Invited",
    src: "/img/svg/vuesax-linear-tick-square.svg",
    alt: "up",
    className: "grey",
    id: JSON.stringify([["joinedAt"], ["desc"]]),
  },
  {
    title: "First Invited",
    src: "/img/svg/vuesax-linear-tick-square.svg",
    alt: "down",
    className: "grey rotate",
    id: JSON.stringify([["joinedAt"], ["asc"]]),
  },
];

export const SubHeader = ({
  activeToggle,
  updateToggleActive,
  locals,
  referAsClients,
  isAllowToViewAllOrganizationsCoaches,
}) => {
  const {
    activeUser,
    organizationRoles = [],
    usersOrganization = {
      organizationActiveUsers: [],
    },
    query,
  } = locals;
  const { organizationActiveUsers = [] } = usersOrganization;
  const selectOrganizationCoach = (e, coach) => {
    e.stopPropagation();
    e.preventDefault();
    // setCurrentCoach(coach);
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        organizationCoach: coach._id,
        filterGroup: "",
      },
    });
  };
  const coach = !!query.organizationCoach
    ? organizationActiveUsers.find(
        (obj) => obj._id.toString() === query.organizationCoach.toString()
      )
    : activeUser;
  const [currentCoach, setCurrentCoach] = useState(coach);

  useEffect(() => {
    const updatedCoach = !!query.organizationCoach
      ? organizationActiveUsers.find(
          (obj) => obj._id.toString() === query.organizationCoach.toString()
        )
      : activeUser;

    if (updatedCoach) {
      setCurrentCoach(updatedCoach);
    }
  }, [query.organizationCoach]);
  return (
    <>
      {/* choose coach only for mobile */}
      {isAllowToViewAllOrganizationsCoaches && (
        <div className="force-only-show-mobile">
          <ChooseCoach
            activeUser={activeUser}
            organizationActiveUsers={organizationActiveUsers}
            // query={locals.query}
            isFrom="list"
            onSelectCoach={selectOrganizationCoach}
            selectedCoach={currentCoach}
          />
        </div>
      )}
      <hgroup>
        <TablistNav
          name="filters[status.inactive]"
          defaultActive={activeToggle}
          options={[
            {
              text: "All",
              value: "all",
              href: "/actions/refresh?filters[status.inactive]=all&&name=",
            },
            { text: "Active", value: false, dataStatus: "active" },
            { text: "Inactive", value: true, dataStatus: "inactive" },
          ]}
          callback={updateToggleActive}
        />
        {/* desktop */}
        <DropdownIconsCheck
          title="Sort"
          items={SORT_ITEMS}
          classNames="mobile-hidden"
          action={(sort) => {
            submit(`/actions/refresh`, {
              method: "GET",
              body: { sort },
            });
          }}
        />
        <div className="watch-organization-coaches-for-athletes">
          {isAllowToViewAllOrganizationsCoaches && (
            <>
              {/* Only to desktop */}
              <ChooseCoach
                classNames="force-mobile-hidden"
                activeUser={activeUser}
                organizationActiveUsers={organizationActiveUsers}
                // query={locals.query}
                isFrom="list"
                onSelectCoach={selectOrganizationCoach}
                selectedCoach={currentCoach}
              />
            </>
          )}
          <a
            role="button"
            data-button-type="primary"
            data-icon
            href={`/coaching-portal/athletes/?modal[type]=invite-athlete`}
          >
            <SvgIcon
              src="/img/new-icons/add.svg"
              alt={`Ad ${referAsClients ? "client" : "athlete"}`}
              noFilterOnLight={true}
            />
            Add {referAsClients ? "Client" : "Athlete"}
          </a>
        </div>
      </hgroup>
    </>
  );
};

export const Header = ({
  athletesGroups = [],
  referAsClients,
  isAllowToViewAllOrganizationsCoaches,
  query,
}) => {
  const athletesArrayGroups = athletesGroups || [];

  const clientWord = referAsClients ? "Clients" : "Athletes";

  const groupOptions = isAllowToViewAllOrganizationsCoaches
    ? [
        {
          text: `All ${clientWord}`,
          value: "all",
        },
        {
          text: `All Organization ${clientWord}`,
          value: "organization",
          href: "/actions/refresh?filterGroup=organization",
        },
      ]
    : [
        {
          text: `All ${clientWord}`,
          value: "all",
        },
      ];

  return (
    <div className="head athletes-list-header">
      <div className="left-side">
        {/* <div className="athletes-groups-bar" style={{ display: "none" }}> */}
        <div className="athletes-groups-bar">
          {((athletesArrayGroups && athletesArrayGroups.length > 0) ||
            isAllowToViewAllOrganizationsCoaches) && (
            <>
              {/* desktop */}
              <ToggleLinksInput
                className="force-mobile-hidden"
                name="filterGroup"
                options={[
                  ...groupOptions,
                  ...athletesArrayGroups.map((athleteGroup) => {
                    return {
                      text: athleteGroup.name,
                      value: athleteGroup.name,
                    };
                  }),
                  {
                    text: "Add Group",
                    href: `/coaching-portal/athletes/?modal[type]=new-group`,
                    IconImg: (
                      <SvgIcon src="/img/new-icons/add.svg" alt="add group" />
                    ),
                  },
                ]}
              />
              {/* mobile */}
              <SelectGroupsForMobileScreen
                clientWord={clientWord}
                classNames="force-only-show-mobile"
                query={query}
                options={[
                  ...groupOptions,
                  ...athletesArrayGroups.map((athleteGroup) => {
                    return {
                      text: athleteGroup.name,
                      value: athleteGroup.name,
                    };
                  }),
                ]}
              />
              <DropdownIconsCheck
                title="Sort"
                items={SORT_ITEMS}
                classNamesPositions="modal-position-left-mobile"
                classNames="only-show-mobile"
                action={(sort) => {
                  submit(`/actions/refresh`, {
                    method: "GET",
                    body: { sort },
                  });
                }}
              />
            </>
          )}
          {athletesArrayGroups.length === 0 &&
            !isAllowToViewAllOrganizationsCoaches && (
              <a
                role="button"
                data-button-type="secondary"
                href="/coaching-portal/athletes/?modal[type]=new-group"
              >
                <SvgIcon
                  src="/img/new-icons/add.svg"
                  alt="add group"
                  noFilterOnLight={true}
                />{" "}
                Add group
              </a>
            )}
        </div>
      </div>
    </div>
  );
};

Header.contextTypes = { locals: PropTypes.object };
